<template>
  <div class="tab-content">
    <h4 class="section-title">Data Diri</h4>

    <div class="form-fields">
      <div class="field-group">
        <div class="field">
          <label>Nama Lengkap Tanpa Gelar <span class="required">*</span></label>
          <div class="field-value">{{ data.namaLengkap }}</div>
        </div>
      </div>

      <div class="field-group two-col">
        <div class="field">
          <label>Gelar Depan <span class="required">*</span></label>
          <div class="field-value">{{ data.gelarDepan }}</div>
        </div>
        <div class="field">
          <label>Gelar Belakang <span class="required">*</span></label>
          <div class="field-value">{{ parsedGelarBelakang }}</div>
        </div>
      </div>

      <div class="field-group two-col">
        <div class="field">
          <label>Tempat Lahir <span class="required">*</span></label>
          <div class="field-value">{{ data.tempatLahir }}</div>
        </div>
        <div class="field">
          <label>Tanggal Lahir <span class="required">*</span></label>
          <div class="field-value">{{ data.tanggalLahir }}</div>
        </div>
      </div>

      <div class="field-group">
        <div class="field">
          <label>Jenis Kelamin <span class="required">*</span></label>
          <div class="field-value">{{ data.jenisKelamin }}</div>
        </div>
      </div>

      <div class="field-group two-col">
        <div class="field">
          <label>Kartu Identitas <span class="required">*</span></label>
          <div class="field-value">{{ data.jenisKartuId }}</div>
        </div>
        <div class="field">
          <label>Nomor Kartu Identitas <span class="required">*</span></label>
          <div class="field-value">{{ data.nomorKartuId }}</div>
        </div>
      </div>

      <div class="field-group">
        <div class="field">
          <label>Status Pernikahan <span class="required">*</span></label>
          <div class="field-value">{{ data.statusPernikahan }}</div>
        </div>
      </div>

      <div class="field-group">
        <div class="field">
          <label>Alamat Tempat Tinggal <span class="required">*</span></label>
          <div class="field-value">{{ data.alamat }}</div>
        </div>
        <div class="two-col" style="margin-top: 8px">
          <div class="field-value">{{ data.rt }}</div>
          <div class="field-value">{{ data.rw }}</div>
        </div>
        <div class="two-col" style="margin-top: 8px">
          <div class="field-value">{{ data.kelurahan }}</div>
          <div class="field-value">{{ data.kecamatan }}</div>
        </div>
        <div class="two-col" style="margin-top: 8px">
          <div class="field-value">{{ data.kabupaten }}</div>
          <div class="field-value">{{ data.kodePos }}</div>
        </div>
      </div>

      <div class="field-group">
        <div class="field">
          <label>Telepon <span class="required">*</span></label>
          <div class="field-value">{{ data.telepon }}</div>
        </div>
      </div>

      <div class="field-group">
        <div class="field">
          <label>Handphone <span class="required">*</span></label>
          <div class="field-value">{{ data.handphone }}</div>
        </div>
      </div>

      <div class="field-group">
        <div class="field">
          <label>Email <span class="required">*</span></label>
          <div class="field-value">{{ data.email }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MemberApplicationTabDataDiri',
  props: {
    data: { type: Object, required: true },
  },
  computed: {
    parsedGelarBelakang() {
      const raw = this.data.gelarBelakang
      if (!raw) return '-'
      if (Array.isArray(raw)) return raw.filter(Boolean).join(', ') || '-'
      try {
        const parsed = JSON.parse(raw)
        if (Array.isArray(parsed)) return parsed.filter(Boolean).join(', ') || '-'
      } catch {}
      return raw
    },
  },
}
</script>

<style scoped>
.tab-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.section-title {
  font-size: 20px;
  font-weight: 700;
  color: #282828;
  margin: 0;
}

.form-fields {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.field-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.field-group.two-col {
  flex-direction: row;
  gap: 16px;
}

.field-group.two-col .field {
  flex: 1;
}

.two-col {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.field label {
  display: block;
  font-size: 14px;
  font-weight: 700;
  color: #444;
  margin-bottom: 4px;
}

.required {
  color: #dc3545;
}

.field-value {
  background: #e4e9f0;
  border: 1px solid #e4e9f0;
  border-radius: 6px;
  padding: 4px 16px;
  min-height: 32px;
  font-size: 14px;
  color: #444;
  line-height: 22px;
  display: flex;
  align-items: center;
}
</style>
